import React from 'react';
import {Container} from "@mui/material";
import EventResults from "../Competition/EventResults";
import {useSelector} from "react-redux";

const Results = () => {
    const event = useSelector(state => state.session.event)

    return (
        <Container maxWidth={'lg'}>
            {event &&
                <EventResults event={event}/>
            }
        </Container>
    )
};

export default Results;